/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 */
import StorageTags from './storagetags'

// storage保存数据的key值
export const KEYS = StorageTags

export function setItem (key, value) {
  if (window.localStorage) {
    window.localStorage.setItem(key, JSON.stringify(value))
  }
}

export function getItem (key) {
  if (window.localStorage) {
    var value = window.localStorage.getItem(key)
    if (value) {
      return JSON.parse(value)
    }
    return value
  }
}

export function removeItem (key) {
  if (window.localStorage) {
    window.localStorage.removeItem(key)
  }
}

export function sSetItem (key, value) {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  }
}

export function sGetItem (key) {
  if (window.sessionStorage) {
    var value = window.sessionStorage.getItem(key)
    if (value) {
      return JSON.parse(value)
    }
    return value
  }
}

export function sRemoveItem (key) {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/base/store/storage.js